export default __webpack_public_path__ + "static/media/icons8-instagram.c83e628e.svg";